import React from 'react';
import { JsonLd, JsonLdProps } from 'src/components/jsonld/JsonLd';

export interface PersonJsonLdProps extends JsonLdProps {
  name: string;
  description: string;
  disambiguatingDescription: string;
  url: string;
  image?: string | string[] | Record<string, any> | null;
  sameAs?: string[];
  jobTitle: string;
  email: string;
}

function PersonJsonLd({ type = 'Person', keyOverride, image, ...rest }: PersonJsonLdProps) {
  const data = {
    ...rest,
    image,
  };

  return <JsonLd type={type} keyOverride={keyOverride} scriptKey="Person" {...data} />;
}

export default PersonJsonLd;
